export enum enumGATagEventName {
  Isf = 'isf',
  CustomEvent = 'customEvent',
  CompanyValidated = 'company_validated',
  ViewsOfProductDetails = 'ViewsOfProductDetails',
  PageView = 'page_view',
  ViewItem = 'view_item',
  BeginCheckout = 'begin_checkout',
  CheckoutSteps = 'checkoutSteps',
  AddToCart = 'add_to_cart',
  Purchase = 'purchase',
  Registration = 'registration',
  FBCustomEvent = 'FBCustomEvent',
  FBPurchase = 'FBPurchase',
  FBRegistration = 'FBRegistration',
}
